import { Observable } from "rxjs/Rx";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { HttpService } from "../utils/services/http.service";
import { ErrorsService } from "../utils/services/errors.service";

@Injectable()
export class HttpServiceHelper {
  constructor(
    private http: HttpClient,
    private httpService: HttpService,
    private errorsService: ErrorsService
  ) {}

  public httpGetRequest(url: string) {
    return this.http
      .get(url)
      .map((response) => {
        return response;
      })
      .catch((response) => Observable.throw(response));
  }

  getVerticalDepartments(): Observable<any> {
    return this.httpService
      .get(`verticalDepartment`)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  getCDMODepartments(): Observable<any> {
    return this.httpService
      .get(`cdmoDepartments`)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  handleError(error: any) {
    this.errorsService.handleError(error);
    return Observable.throw(error.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/common/HttpServiceHelper.ts